/**
 * Decouple Cookie library with GDPR compliance built in
 *
 * @author    Will Van Rensselaer <wvanrensselaer@wayfair.com>
 * @author    Evan Cooper <evcooper@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
/* eslint-env browser */

import {setCookie, getCookie, removeCookie} from './core_cookies';
import {createCookieApi} from './gdpr_cookies';

const clientOnServerError = 'Cannot set window.cookieApi on the server.';

const uninitializedError =
  'No window.cookieApi. Call setClientCookieApi(cookieApi).';

export const setClientCookieApi = (cookieApi) => {
  if (typeof window === 'undefined') {
    throw new Error(clientOnServerError);
  }
  window.cookieApi = cookieApi;
};

const getClientCookieApi = () => {
  if (typeof window === 'undefined') {
    throw new Error(clientOnServerError);
  }

  if (!window.cookieApi) {
    throw new Error(uninitializedError);
  }

  return window.cookieApi;
};

export {setCookie, getCookie, removeCookie, createCookieApi};
export default getClientCookieApi;
